/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'

export const isCustomMessageRequired = (item: Listable | Pin | Property) => {
  return !!item.features?.includes(PropertyFeatures.REQ_CUSTOM_MSG)
}
